module.exports = __webpack_public_path__ + "img/image-ppt.42016e7b.png";